import { Component, Input, OnInit } from '@angular/core';
import { Resource, ResSpecificationId } from '../../../../../services/api/ftth-resource/ftth-resource.service';

@Component({
  selector: 'app-properties-widget',
  templateUrl: './properties-widget.component.html',
  styleUrls: ['./properties-widget.component.scss']
})
export class PropertiesWidgetComponent implements OnInit {

  private _resource: Resource;

  @Input()
  get resource(): Resource {
    return this._resource;
  }

  set resource(value: Resource) {
    this._resource = value;
    this.ngOnInit();
  }

  showState = false;
  private readonly stateSpecificationIds: ResSpecificationId[] =
    ['OLTResSpec', 'CTOResSpec', 'CTOPortResSpec'];

  showOccupancy = false;
  private readonly occupancySpecificationIds: ResSpecificationId[] =
    ['OLTResSpec', 'OLTCardResSpec', 'OLTPortResSpec', 'SplitterResSpec', 'CTOResSpec', 'C_VLANSpec'];

  constructor() {
  }

  ngOnInit() {
    if (this.resource) {
      this.showState = this.stateSpecificationIds.includes(this.resource.specificationName);
      this.showOccupancy = this.occupancySpecificationIds.includes(this.resource.specificationName);
    }
  }

}
